module.exports = __webpack_public_path__ + "static/media/step0login.786d5586.svg";